import { render, staticRenderFns } from "./NewLayoutComponent.vue?vue&type=template&id=4b7b2738&"
import script from "./NewLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./NewLayoutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports